"use client";

import { default as NextLink, LinkProps as NextLinkProps } from "next/link";
import { twMerge } from "tailwind-merge";

import { withClickAnalytics } from "../withAnalytics";

export type LinkProps = NextLinkProps & {
  children: React.ReactNode;
  className?: string;
  target?: string;
  rel?: string;
};

const Link = ({ className, ...props }: LinkProps) => (
  <NextLink
    className={twMerge(
      "no-underline hover:brightness-110 transition-colors",
      className
    )}
    {...props}
  />
);

export default withClickAnalytics(Link);
